var _path, _path2, _path3, _path4, _path5, _path6, _rect, _circle, _circle2, _circle3, _rect2, _circle4, _circle5, _rect3, _circle6, _circle7, _circle8, _rect4, _circle9, _circle10, _rect5, _circle11, _circle12, _rect6, _circle13, _rect7, _circle14, _circle15, _rect8, _circle16, _circle17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 349,
    height: 131,
    viewBox: "0 0 349 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.217 88.0701C103.26 88.0701 100.587 87.5638 98.1974 86.5512C95.8482 85.5386 93.985 84.0804 92.6078 82.1767C91.2307 80.273 90.5219 78.0251 90.4814 75.4328H99.5948C99.7163 77.1745 100.324 78.5516 101.417 79.5642C102.552 80.5768 104.091 81.0831 106.035 81.0831C108.02 81.0831 109.579 80.6173 110.713 79.6857C111.847 78.7136 112.414 77.458 112.414 75.9189C112.414 74.6632 112.03 73.6304 111.26 72.8203C110.49 72.0102 109.518 71.3824 108.344 70.9369C107.21 70.4508 105.63 69.9243 103.605 69.3572C100.85 68.5471 98.6024 67.7573 96.8608 66.9877C95.1596 66.1776 93.6812 64.9828 92.4256 63.4031C91.2104 61.783 90.6029 59.6363 90.6029 56.963C90.6029 54.4517 91.2307 52.2645 92.4863 50.4013C93.7419 48.5382 95.5039 47.1205 97.7721 46.1484C100.04 45.1358 102.633 44.6295 105.549 44.6295C109.923 44.6295 113.467 45.7029 116.181 47.8496C118.935 49.9558 120.454 52.9126 120.738 56.72H111.381C111.3 55.2618 110.673 54.0669 109.498 53.1354C108.364 52.1633 106.845 51.6772 104.941 51.6772C103.281 51.6772 101.944 52.1025 100.931 52.9531C99.9593 53.8037 99.4733 55.039 99.4733 56.6592C99.4733 57.7933 99.8378 58.7452 100.567 59.5147C101.336 60.2438 102.268 60.8514 103.362 61.3374C104.496 61.783 106.075 62.3095 108.101 62.9171C110.855 63.7272 113.103 64.5372 114.845 65.3473C116.586 66.1574 118.085 67.3725 119.34 68.9927C120.596 70.6128 121.224 72.7393 121.224 75.3721C121.224 77.6403 120.637 79.7465 119.462 81.6907C118.287 83.6349 116.566 85.1943 114.298 86.3689C112.03 87.503 109.336 88.0701 106.217 88.0701ZM154.602 79.5642H137.712L134.917 87.6448H125.986L141.235 45.1763H151.139L166.388 87.6448H157.397L154.602 79.5642ZM152.293 72.7596L146.157 55.0188L140.02 72.7596H152.293ZM203.013 58.3604C203.013 60.6286 202.467 62.7551 201.373 64.7398C200.32 66.7245 198.639 68.3244 196.33 69.5395C194.062 70.7546 191.186 71.3622 187.703 71.3622H180.594V87.6448H172.089V45.2371H187.703C190.984 45.2371 193.778 45.8041 196.087 46.9382C198.396 48.0724 200.117 49.6318 201.251 51.6165C202.426 53.6012 203.013 55.8491 203.013 58.3604ZM187.338 64.4967C189.688 64.4967 191.429 63.9702 192.563 62.9171C193.697 61.8235 194.265 60.3046 194.265 58.3604C194.265 54.229 191.956 52.1633 187.338 52.1633H180.594V64.4967H187.338ZM217.558 45.2371V87.6448H209.052V45.2371H217.558ZM245.647 88.0701C241.678 88.0701 238.032 87.1385 234.711 85.2753C231.39 83.4121 228.757 80.8401 226.813 77.5593C224.868 74.2379 223.896 70.4913 223.896 66.3194C223.896 62.188 224.868 58.4819 226.813 55.2011C228.757 51.8797 231.39 49.2875 234.711 47.4243C238.032 45.5611 241.678 44.6295 245.647 44.6295C249.657 44.6295 253.302 45.5611 256.583 47.4243C259.904 49.2875 262.517 51.8797 264.421 55.2011C266.365 58.4819 267.337 62.188 267.337 66.3194C267.337 70.4913 266.365 74.2379 264.421 77.5593C262.517 80.8401 259.904 83.4121 256.583 85.2753C253.262 87.1385 249.616 88.0701 245.647 88.0701ZM245.647 80.4756C248.199 80.4756 250.447 79.9085 252.391 78.7744C254.335 77.5998 255.854 75.9391 256.948 73.7924C258.041 71.6457 258.588 69.1547 258.588 66.3194C258.588 63.4841 258.041 61.0134 256.948 58.9072C255.854 56.7605 254.335 55.1201 252.391 53.9859C250.447 52.8518 248.199 52.2848 245.647 52.2848C243.095 52.2848 240.827 52.8518 238.842 53.9859C236.898 55.1201 235.379 56.7605 234.286 58.9072C233.192 61.0134 232.645 63.4841 232.645 66.3194C232.645 69.1547 233.192 71.6457 234.286 73.7924C235.379 75.9391 236.898 77.5998 238.842 78.7744C240.827 79.9085 243.095 80.4756 245.647 80.4756ZM282.049 45.2371V71.4837C282.049 74.3595 282.799 76.5669 284.297 78.1061C285.796 79.6047 287.902 80.3541 290.616 80.3541C293.37 80.3541 295.497 79.6047 296.995 78.1061C298.494 76.5669 299.243 74.3595 299.243 71.4837V45.2371H307.81V71.4229C307.81 75.0278 307.02 78.0858 305.44 80.5971C303.901 83.0678 301.815 84.931 299.183 86.1866C296.59 87.4423 293.694 88.0701 290.494 88.0701C287.335 88.0701 284.459 87.4423 281.867 86.1866C279.315 84.931 277.29 83.0678 275.791 80.5971C274.293 78.0858 273.544 75.0278 273.544 71.4229V45.2371H282.049Z",
    fill: "#1E5A64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M330.67 88.0701C327.714 88.0701 325.04 87.5638 322.651 86.5512C320.301 85.5386 318.438 84.0804 317.061 82.1767C315.684 80.273 314.975 78.0251 314.934 75.4328H324.048C324.169 77.1745 324.777 78.5516 325.871 79.5642C327.005 80.5768 328.544 81.0831 330.488 81.0831C332.473 81.0831 334.032 80.6173 335.166 79.6857C336.3 78.7136 336.867 77.458 336.867 75.9189C336.867 74.6632 336.483 73.6304 335.713 72.8203C334.943 72.0102 333.971 71.3824 332.797 70.9369C331.663 70.4508 330.083 69.9243 328.058 69.3572C325.304 68.5471 323.056 67.7573 321.314 66.9877C319.613 66.1776 318.134 64.9828 316.879 63.4031C315.664 61.783 315.056 59.6363 315.056 56.963C315.056 54.4517 315.684 52.2645 316.939 50.4013C318.195 48.5382 319.957 47.1205 322.225 46.1484C324.493 45.1358 327.086 44.6295 330.002 44.6295C334.376 44.6295 337.921 45.7029 340.634 47.8496C343.389 49.9558 344.907 52.9126 345.191 56.72H335.835C335.754 55.2618 335.126 54.0669 333.951 53.1354C332.817 52.1633 331.298 51.6772 329.394 51.6772C327.734 51.6772 326.397 52.1025 325.385 52.9531C324.412 53.8037 323.926 55.039 323.926 56.6592C323.926 57.7933 324.291 58.7452 325.02 59.5147C325.79 60.2438 326.721 60.8514 327.815 61.3374C328.949 61.783 330.529 62.3095 332.554 62.9171C335.308 63.7272 337.556 64.5372 339.298 65.3473C341.039 66.1574 342.538 67.3725 343.794 68.9927C345.049 70.6128 345.677 72.7393 345.677 75.3721C345.677 77.6403 345.09 79.7465 343.915 81.6907C342.74 83.6349 341.019 85.1943 338.751 86.3689C336.483 87.503 333.789 88.0701 330.67 88.0701Z",
    fill: "#07A3E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9903 21.871C9.91119 33.9501 9.91119 53.5342 21.9903 65.6133L40.3871 84.0101C40.748 84.371 41.1155 84.7211 41.4894 85.0604L48.8096 77.7402C48.3913 77.3837 47.9839 77.0078 47.5885 76.6125L29.3917 58.4156C21.3436 50.3675 21.3436 37.3189 29.3917 29.2708C36.2066 22.4558 46.607 21.4116 54.5207 26.138L61.986 18.6727C49.8934 9.90753 32.8877 10.9736 21.9903 21.871Z",
    fill: "#07A3E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9903 65.6133C9.91119 53.5342 9.91119 33.9501 21.9903 21.871C34.0694 9.79192 53.6535 9.79192 65.7326 21.871C76.8163 32.9547 77.7297 50.3574 68.4728 62.4826L61.1694 55.1791C66.47 47.1397 65.5828 36.2199 58.5077 29.1448C50.4181 21.0553 37.3024 21.0553 29.2128 29.1448C27.9822 30.3754 26.9388 31.7224 26.0826 33.1502C25.1862 33.6745 24.3415 34.321 23.5728 35.0897C18.7384 39.9241 18.7384 47.7623 23.5728 52.5968L27.5812 56.6051C28.0826 57.2405 28.6264 57.8533 29.2128 58.4397C29.7992 59.0261 30.412 59.5699 31.0474 60.0713L45.6001 74.6241C37.1153 75.0989 28.4722 72.0953 21.9903 65.6133Z",
    fill: "#07A3E9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4179 109.128C77.497 97.0494 77.497 77.4653 65.4179 65.3862L47.0211 46.9894C46.6612 46.6295 46.2947 46.2803 45.9219 45.9419L38.6031 53.2607C39.0216 53.6173 39.4292 53.9934 39.8247 54.3889L58.0215 72.5857C66.0696 80.6338 66.0696 93.6824 58.0215 101.731C51.2064 108.546 40.8057 109.59 32.8919 104.863L25.4256 112.329C37.518 121.092 54.5215 120.025 65.4179 109.128Z",
    fill: "#1E5A64"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4179 65.3862C77.497 77.4653 77.497 97.0494 65.4179 109.128C53.3388 121.208 33.7547 121.208 21.6756 109.128C10.5912 98.0441 9.67839 80.6399 18.9372 68.5146L26.2417 75.8192C20.9394 83.8587 21.8262 94.7798 28.9019 101.856C36.9915 109.945 50.1072 109.945 58.1968 101.856C59.4265 100.626 60.4693 99.2801 61.3251 97.8534C62.2236 97.3286 63.0701 96.681 63.8404 95.9108C68.6748 91.0763 68.6748 83.2381 63.8404 78.4037L59.815 74.3783C59.3173 73.749 58.7779 73.1419 58.1968 72.5607C57.6156 71.9796 57.0086 71.4402 56.3793 70.9425L41.8119 56.3752C50.2955 55.9016 58.937 58.9052 65.4179 65.3862Z",
    fill: "#1E5A64"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.5547,
    y: 43.6221,
    width: 5.20091,
    height: 0.449234,
    transform: "rotate(45 40.5547 43.6221)",
    fill: "#07A3E9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.3516,
    cy: 47.6693,
    r: 0.797473,
    transform: "rotate(45 44.3516 47.6693)",
    fill: "#1E5A64"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.7969,
    cy: 44.1141,
    r: 0.797473,
    transform: "rotate(45 40.7969 44.1141)",
    fill: "#07A3E9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.502,
    cy: 45.8202,
    r: 0.504691,
    transform: "rotate(45 42.502 45.8202)",
    fill: "#07A3E9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37.0156,
    y: 45.5498,
    width: 5.20091,
    height: 0.41348,
    rx: 0.20674,
    transform: "rotate(1.63136 37.0156 45.5498)",
    fill: "#07A3E9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.2401,
    cy: 85.9977,
    r: 0.797473,
    transform: "rotate(5.93351 49.2401 85.9977)",
    fill: "#1E5A64"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.9029,
    cy: 45.8789,
    r: 0.504691,
    transform: "rotate(5.93351 39.9029 45.8789)",
    fill: "#07A3E9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36.6484,
    y: 48.1436,
    width: 5.20091,
    height: 0.455821,
    transform: "rotate(25.3794 36.6484 48.1436)",
    fill: "#07A3E9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5596,
    cy: 48.5039,
    r: 0.639601,
    transform: "rotate(25.3794 36.5596 48.5039)",
    fill: "#07A3E9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.1635,
    cy: 49.6069,
    r: 0.504691,
    transform: "rotate(25.3794 39.1635 49.6069)",
    fill: "#07A3E9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.291,
    cy: 50.6883,
    r: 0.797473,
    transform: "rotate(45 41.291 50.6883)",
    fill: "#1E5A64"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36.4277,
    y: 48.3286,
    width: 5.20091,
    height: 0.472143,
    rx: 0.236072,
    transform: "rotate(48.5032 36.4277 48.3286)",
    fill: "#07A3E9"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.1537,
    cy: 50.668,
    r: 0.504691,
    transform: "rotate(48.5032 38.1537 50.668)",
    fill: "#07A3E9"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.684,
    cy: 52.4972,
    r: 0.797473,
    transform: "rotate(68.1238 39.684 52.4972)",
    fill: "#1E5A64"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 5.20091,
    height: 0.469595,
    rx: 0.234798,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 51.4199 82.5464)",
    fill: "#1E5A64"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    r: 0.797473,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 47.3449 78.8247)",
    fill: "#07A3E9"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    r: 0.504691,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 49.1886 80.6733)",
    fill: "#1E5A64"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 5.20091,
    height: 0.407351,
    rx: 0.203675,
    transform: "matrix(-0.043274 -0.999063 -0.999063 0.043274 49.4961 86.1582)",
    fill: "#1E5A64"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    r: 0.504691,
    transform: "matrix(-0.103374 -0.994642 -0.994642 0.103374 49.1255 83.2733)",
    fill: "#1E5A64"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 6.02904,
    height: 0.409592,
    rx: 0.204796,
    transform: "matrix(-0.428611 -0.903489 -0.903489 0.428611 47.1816 87.2959)",
    fill: "#1E5A64"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    r: 0.504691,
    transform: "matrix(-0.428611 -0.903489 -0.903489 0.428611 45.4039 84.0133)",
    fill: "#1E5A64"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    r: 0.797473,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 44.3234 81.8867)",
    fill: "#07A3E9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 5.86019,
    height: 0.32812,
    rx: 0.16406,
    transform: "matrix(-0.748993 -0.662578 -0.662578 0.748993 47.1289 87.2393)",
    fill: "#1E5A64"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    r: 0.504691,
    transform: "matrix(-0.748993 -0.662578 -0.662578 0.748993 44.3423 85.0177)",
    fill: "#1E5A64"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    r: 0.797473,
    transform: "matrix(-0.927991 -0.372603 -0.372603 0.927991 42.5116 83.4873)",
    fill: "#07A3E9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.3ca99470c7925de855145078cbad5564.svg";
export { ForwardRef as ReactComponent };